import UpdateGlaromatUserRequestModelBase from '../_generated/modelBases/update-glaromat-user-request-model-base';

export default class UpdateGlaromatUserRequestModel extends UpdateGlaromatUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
